const storeStatus = {
  active: 1,
  disabled: 2,
  rejected: 3,
  underReview: 4,
  notCompleted: 5
};

export default storeStatus;
